import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";

function UserDashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  // 🔒 Login Check
  if (!user) {
    navigate("/login");
    return null;
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    alert("Logged out successfully!");
    navigate("/login");
  };

  return (
    <div>
      <nav
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          background: "#343a40",
          color: "white",
          padding: "10px 20px",
        }}
      >
        {/* <h2>👤 {user.username}'s Dashboard</h2> */}
        <h2>👤 {user.name || user.email}'s Dashboard</h2>

        <div>
          {/* 🛍️ Replaced Home with Products */}
          <Link to="/userdashboard/products" style={navLink}>
            🛍️ Products
          </Link>

          <Link to="/userdashboard/cart" style={navLink}>
            🛒 Cart
          </Link>

          <Link to="/userdashboard/checkout" style={navLink}>
            💳 Checkout
          </Link>

          <Link to="/userdashboard/myorders" style={navLink}>
            📦 My Orders
          </Link>

          <button
            onClick={handleLogout}
            style={{
              background: "#dc3545",
              color: "white",
              border: "none",
              borderRadius: "5px",
              padding: "6px 10px",
              cursor: "pointer",
              marginLeft: "10px",
            }}
          >
            🚪 Logout
          </button>
        </div>
      </nav>

      <div style={{ padding: "20px" }}>
        <Outlet />
      </div>
    </div>
  );
}

const navLink = {
  color: "white",
  textDecoration: "none",
  marginRight: "15px",
  fontWeight: "500",
};

export default UserDashboard;
